export * from "./brand.module";
export * from "./brand.component";


// WEBPACK FOOTER //
// ./src/app/public/brand/index.ts